module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/customer-pre-login/mobile-force/mobile-force.component.scss
// module id = ./src/app/components/customer-pre-login/mobile-force/mobile-force.component.scss
// module chunks = main